import New_C_Sign_Up_2025   from "../components/New_C_Sign_Up_2025";

const new_p_sign_up_2025 = () => {

  return (
            <div>
            
            <New_C_Sign_Up_2025/>
            
        </div>

  )
}


export default new_p_sign_up_2025;
